import clsx from "clsx"
import { spacedNum } from "@/components/common/CommonHelper"
import Table from "@/ui/components/Table"

import type { FC } from "react"

import style from "../../style.module.scss"

type Props = {
  balances?: Record<string, number>
}

const tableColumns: string[] = ["USD", "EUR", "AED", "CNY", "IDR"]

export const BalanceTotal: FC<Props> = ({ balances }) => {
  return (
    <Table.Wrapper title="Общий баланс">
      <Table.Header className={style.totalTableRow} columns={tableColumns} />
      <Table.Item className={clsx(style.totalTableRow, style.totalTableItemRow)}>
        <div>{balances?.["USD"] ? spacedNum(balances?.["USD"] / 100) : 0}</div>
        <div>{balances?.["EUR"] ? spacedNum(balances?.["EUR"] / 100) : 0}</div>
        <div>{balances?.["AED"] ? spacedNum(balances?.["AED"] / 100) : 0}</div>
        <div>{balances?.["CNY"] ? spacedNum(balances?.["CNY"] / 100) : 0}</div>
        <div>{balances?.["IDR"] ? spacedNum(balances?.["IDR"] / 100) : 0}</div>
      </Table.Item>
    </Table.Wrapper>
  )
}
